export default {"src":"/org/_next/static/media/arrow-down.0a0eeb19.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};